import { customToast, dev_console, getR2DirectDownloadUrl } from "../../../../../Common/ts/commonTools";
import { webViewBridgeClass } from "../../../../../Common/ts/appTools";

const webViewBridge = new webViewBridgeClass();

// 사진 다운로드 기능 핸들러 함수
export const handleFileDownload = async (
    {
        brand_id,
        upload_file_pk,
        file_name,
        file_size,
    }:{
        brand_id: number;
        upload_file_pk: number;
        file_name?: string;
        file_size?: number;
    }
) => {
    if(!window.confirm("사진들을 다운로드하시겠습니까?")){
        return ;
    }

    try{
        const m_getR2DirectDownloadUrl_response = await getR2DirectDownloadUrl({
            brand_id,
            upload_file_pk,
            file_name,
        })

        if(webViewBridge.isUseFlutterWebView()){
            // // 앱 배포 완료전 까지 앱에서의 다운로드 기능 중단
            // customToast.info({
            //     msg: "앱 기능의 개편으로 다운로드 기능이 잠시 준비 중에 있습니다. PC에서 다운로드 해주세요."
            // });

            // return ;

            if(file_size && (file_size > 1024 * 1024 * 1024)){
                customToast.error({
                    msg: "파일 용량이 1GB 이상입니다.\n웹 환경에서 다운로드 해주세요.",
                })

                return ;
            }

            customToast.info({
                msg: "곧 다운로드가 시작됩니다. 잠시 기다려주세요.",
            })

            // flutter web_view환경에서 이미지 다운로드를 위해 보내는 요청
            const m_setDownloadUrl_response = await webViewBridge.setDownloadUrl({
                pull_url: m_getR2DirectDownloadUrl_response,
                file_size: file_size,
            });
        }else{
            customToast.info({
                msg: "곧 다운로드가 시작됩니다. 잠시 기다려주세요.",
            })

            window.location.href = m_getR2DirectDownloadUrl_response;
        }
    }catch(error){
        dev_console.error(error);
        customToast.error({
            msg: "다운로드 중 오류가 발생했습니다.",
        })
    }
}